import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'o3-core-forbidden',
  imports: [RouterModule],
  templateUrl: './forbidden.html',
  styleUrl: './forbidden.css',
})
export class Forbidden {}
